import React from 'react';
import { useAuth } from './context/AuthProvider';
import { Routes, Route, Navigate } from 'react-router-dom';

// COMPONENTES PARA RUTAS
import MainSideBar from './components/plantilla/sidebar/MainSideBar';
import Login from './pages/login/Login';
import Dashboard from './pages/dashboard/Dashboard';
import FormularioInspeccion from './pages/inspecciones/FormularioInspeccion';
import CircleCanva from './pages/inspecciones/CircleCanva';

// CATALOGOS
 

// FUEL REPORT


// TELEMATICA CLIENTES


const Main = () => {

    const { isLoggedIn } = useAuth();

    return (

        <div className="App">

            <div 
                style={{ 
                    backgroundColor: '#f2f4f4', 
                    width: '100vw', 
                    minHeight: '100vh',
                    height: 'auto',
                    display: 'flex',
                }}
            >

                {/* VALIDAMOS SI ESTA LOGUEADO PARA MOSTRAR EL SIDEBAR */}

                {/* {
                    isLoggedIn && ( <MainSideBar/> )
                } */}

                <div 
                    style={{ 
                        flex: 1, 
                        padding: '0px',
                        marginTop: '0px',
                        overflow: 'auto'
                    }}
                >

                    {/* RUTEO PARA PAGINAS */}

                    <Routes>

                        {/* VALIDAR LOGIN */}
                        <Route 
                            path='/' 
                            element={isLoggedIn ? ( <Login/> ) : (
                                window.location.hostname === 'localhost'
                                ? <Login/>
                                : <Login/>
                            )}
                        /> 
{/*                         <Route 
                            path='/' 
                            element={isLoggedIn ? <Login /> : <Navigate to="https://ebtapps.com/" replace />}
                        /> */}
                        {/* DASHBOARD */}
                        <Route 
                            path='/dashboard' 
                            element={isLoggedIn ? ( <Dashboard/> ): (
                                window.location.hostname === 'localhost'
                                ? <Dashboard/>
                                : <Dashboard/>
                            )}
                        />

                        {/* ----------------------------------------------------------- */}


                    </Routes>

                </div>

            </div>

        </div>

    )

}

export default Main